// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"6f101e12","787":"87fe8b95"}[chunkId] + ".chunk.js";
};